import axios from "axios";

// export const baseUrl=`http://localhost:5080/`;
// export const baseUrl=`/`;
export const baseUrl=`https://tech.rashigames.com/`;

export const getGamesApi=async()=>{
    const response=await axios.get(`${baseUrl}api/v1/games`);
    return response;
}

const gamesApi=`${baseUrl}api/content`;
export {gamesApi};

const loginApi=`${baseUrl}api/login`;
export {loginApi};

const subscribeApi=`${baseUrl}subscribe-user`;
export {subscribeApi};

const deactivateApi=`${baseUrl}deactivate-user`;
export {deactivateApi};